import { FormattedNumber } from 'react-intl';
import { getDisplayCurrency } from '../utils/localToCurrency';
import { SupportedCurrency } from '../interfaces/ITicket';

interface CurrencyDisplayProps {
    value: number;
    /** The amount's actual currency (e.g. a ticket's Currency) - takes precedence over the base-currency fallback. */
    currency?: SupportedCurrency;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({ value, currency }) => {
    const resolvedCurrency = currency ?? getDisplayCurrency();

    return (
        <FormattedNumber value={value} style="currency" currency={resolvedCurrency} currencyDisplay="narrowSymbol" />
    );
};

export default CurrencyDisplay;